import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import LoadingOverlay from '../LoadingOverlay';
import { useFirstRender } from '../hooks/FirstRenderHook';
import Details from './property_group/Details';
import Permissions from './property_group/Permissions';
import Properties from './property_group/Properties/Properties';

function PropertyGroup(props) {
  const [loadingPropertyGroup, setLoadingPropertyGroup] = useState(false);

  const firstRender = useFirstRender();

  useEffect(() => {
    if (!firstRender) props.history.replace('/property-groups');
  }, [props.selectedDatabase]);

  useEffect(() => {
    if (
      props.propertyGroup &&
      (!props.propertyGroup.properties || !props.propertyGroup.users)
    ) {
      setLoadingPropertyGroup(true);
      fetch(
        `${process.env.REACT_APP_PROPERTIES_API_URL}api/property-groups/${props.propertyGroup.id}?append[]=userProperty&with[]=properties&with[]=users.propertyRole&withTrashed=true`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${props.bearerToken}`,
            SeasonalDatabase: props.selectedDatabase
          }
        }
      )
        .then((res) => {
          if (res.ok) return res.json();
          else if (res.status === 401) props.refreshBearerToken();
          else throw Error(res.statusText);
        })
        .then((data) => {
          if (data) {
            props.update(data);
          }
        })
        .catch((err) => {
          if (process.env.NODE_ENV === 'development') console.error(err);
        })
        .finally(() => {
          setLoadingPropertyGroup(false);
        });
    }
  }, [props.bearerToken, props.selectedDatabase, props.propertyGroup]);

  return loadingPropertyGroup ? (
    <LoadingOverlay />
  ) : !props.propertyGroup.properties || !props.propertyGroup.users ? null : (
    <Fragment>
      <Row>
        <Col>
          <Button variant='outline-secondary' onClick={props.close}>
            Back
          </Button>
        </Col>
      </Row>
      <Row className='mt-2'>
        <Col>
          {/* Details */}
          <Row>
            <Col>
              <Details
                bearerToken={props.bearerToken}
                selectedDatabase={props.selectedDatabase}
                refreshBearerToken={props.refreshBearerToken}
                propertyGroup={props.propertyGroup}
                update={props.update}
              />
            </Col>
          </Row>

          {/* Permissions */}
          {props.propertyGroup.userProperty.can_edit ? (
            <Row className='mt-4'>
              <Col>
                <Permissions
                  bearerToken={props.bearerToken}
                  selectedDatabase={props.selectedDatabase}
                  refreshBearerToken={props.refreshBearerToken}
                  propertyGroup={props.propertyGroup}
                  update={props.update}
                  users={props.users}
                  propertyRoles={props.propertyRoles}
                />
              </Col>
            </Row>
          ) : null}
        </Col>

        {/* Properties */}
        <Col>
          <Properties
            bearerToken={props.bearerToken}
            selectedDatabase={props.selectedDatabase}
            refreshBearerToken={props.refreshBearerToken}
            propertyGroup={props.propertyGroup}
            update={props.update}
            history={props.history}
          />
        </Col>
      </Row>
    </Fragment>
  );
}

PropertyGroup.propTypes = {
  // Authentication
  bearerToken: PropTypes.string.isRequired,
  refreshBearerToken: PropTypes.func.isRequired,
  selectedDatabase: PropTypes.string.isRequired,

  // Property Group
  propertyGroup: PropTypes.object.isRequired,
  update: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,

  // Other data
  propertyRoles: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired
};

export default PropertyGroup;
